module.exports = __webpack_public_path__ + "images/emoji/up.2e469dcd97604f66bebd.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/up.png
// module id = PkhH
// module chunks = 13